// extracted by mini-css-extract-plugin
export var facebook = "libSocials-module--facebook--cc851";
export var icon = "libSocials-module--icon--f926e";
export var instagram = "libSocials-module--instagram--3bc16";
export var news = "libSocials-module--news--1f940";
export var twitter = "libSocials-module--twitter--9ef74";
export var ug_socials = "libSocials-module--ug_socials--58513";
export var youtube = "libSocials-module--youtube--0dc32";